import {
    createStore as _createStore,
    applyMiddleware,
    combineReducers,
    compose
  } from 'redux';

  export let store;
  /**
   * 
   * @param {*} models 
   * @param {*} reducers 这个不是model里的reducers
   * @param {*} initialState 
   * @param {*} middlewares 
   */
  export function createStore(models,reducers,initialState,middlewares=[]){
    const middleware = applyMiddleware(
        ...middlewares,
    );
    let composeEnhancers = compose;
  // Following line to exclude from coverage report:
  /* istanbul ignore next */
  if (0) {//
    // Redux devtools extension support.
    if (global.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) {
      composeEnhancers = global.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    } 
  }
  const enhancer = composeEnhancers(...[middleware]);
  const reducer = createReducer(models, reducers);
  store = _createStore(reducer, initialState, enhancer)
  return store;


  }
  
  export function replaceReducer(store, models, reducers) {
    const reducer = createReducer(models, reducers)
    store.replaceReducer(reducer)
  }

  function createReducer(models, reducers) {
    //合并models里的reducer
    const modelReducers = models.reduce((acc, cur) => {
      acc[cur.name] = cur.reducer
      return acc
    }, {})
  
    return combineReducers({
      ...reducers,
      ...modelReducers,
    })
  
  }


